"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __importDefault(require("../error"));
var schema_1 = __importDefault(require("./schema"));
var constants_1 = require("../constants");
exports.getVariations = function (validationSchema) {
    var variations = validationSchema.find(function (key) { return Array.isArray(key); });
    var staticKeys = validationSchema.filter(function (key) { return !Array.isArray(key); });
    if (!(variations === null || variations === void 0 ? void 0 : variations.length)) {
        return [validationSchema];
    }
    return variations.map(function (variation) {
        return [].concat(staticKeys).concat([variation]);
    });
};
exports.getValidationSchema = function (cmd) {
    if (!cmd) {
        throw new error_1.default('No method passed');
    }
    var validationSchema = schema_1.default[cmd];
    if (!validationSchema) {
        throw new error_1.default("No such method " + cmd);
    }
    return validationSchema;
};
exports.validate = function (validationSchema, options) {
    var optionKeys = Object.keys(options);
    var validationRules = exports.getVariations(validationSchema);
    return validationRules.some(function (rule) { return rule.every(function (r) { return optionKeys.includes(r); }); });
};
exports.validateMassWithDrawal = function (options) {
    var regex = /(wd\[wd[0-9]*\]\[(amount|address|currency|dest_tag)\]|cmd)/;
    return Object.keys(options).every(function (key) { return regex.test(key); });
};
exports.validatePayload = function (options) {
    if (options.cmd === constants_1.CMDS.CREATE_MASS_WITHDRAWAL) {
        if (!exports.validateMassWithDrawal(options)) {
            throw new error_1.default('Invalid mass withdrawal payload', options);
        }
    }
    var validationSchema = exports.getValidationSchema(options.cmd);
    if (!exports.validate(validationSchema, options)) {
        throw new error_1.default('Missing parameters', options);
    }
};
